// source: ingester.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.suki.pb.ingester.APLocation', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddAnalyticsTransactionRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddStatus', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedAPLocation', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedContact', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedFacility', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedGroup', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedIntent', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedOutsideBuddy', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedSlotType', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedSlotValueType', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedUser', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AddedVoceraBuddy', null, global);
goog.exportSymbol('proto.suki.pb.ingester.AnalyticsTransaction', null, global);
goog.exportSymbol('proto.suki.pb.ingester.Contact', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteAPLocationRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteContactRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteFacilityRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteGroupRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteOutsideBuddyRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteUserRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.DeleteVoceraBuddyRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.Facility', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetAPLocationsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetAPLocationsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetAnalyticsTransactionsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetAnalyticsTransactionsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetContactsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetContactsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetDBMetadataResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetFacilitiesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetFacilitiesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetGroupsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetGroupsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetNormalizedGroupsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetNormalizedGroupsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetNotNormalizedGroupsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetNotNormalizedGroupsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetOutsideBuddiesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetOutsideBuddiesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetProjectIdsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetUsersRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetUsersResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetVoceraBuddiesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.GetVoceraBuddiesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.Group', null, global);
goog.exportSymbol('proto.suki.pb.ingester.HealthCheckRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.HealthCheckResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.Intent', null, global);
goog.exportSymbol('proto.suki.pb.ingester.NormalizedGroup', null, global);
goog.exportSymbol('proto.suki.pb.ingester.OutsideBuddy', null, global);
goog.exportSymbol('proto.suki.pb.ingester.SlotType', null, global);
goog.exportSymbol('proto.suki.pb.ingester.TableUpdatedTime', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertAPLocationsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertAPLocationsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertContactsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertContactsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertFacilitiesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertFacilitiesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertGroupsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertGroupsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertIntentsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertIntentsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertNormalizedGroupsRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertNormalizedGroupsResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertOutsideBuddiesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertOutsideBuddiesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertSlotTypesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertSlotTypesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertSlotValueTypesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertSlotValueTypesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertUsersRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertUsersResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertVoceraBuddiesRequest', null, global);
goog.exportSymbol('proto.suki.pb.ingester.UpsertVoceraBuddiesResponse', null, global);
goog.exportSymbol('proto.suki.pb.ingester.User', null, global);
goog.exportSymbol('proto.suki.pb.ingester.VoceraBuddy', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetProjectIdsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetProjectIdsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetProjectIdsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetProjectIdsResponse.displayName = 'proto.suki.pb.ingester.GetProjectIdsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.Intent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.Intent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.Intent.displayName = 'proto.suki.pb.ingester.Intent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedIntent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedIntent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedIntent.displayName = 'proto.suki.pb.ingester.AddedIntent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertIntentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertIntentsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertIntentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertIntentsRequest.displayName = 'proto.suki.pb.ingester.UpsertIntentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertIntentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertIntentsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertIntentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertIntentsResponse.displayName = 'proto.suki.pb.ingester.UpsertIntentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.SlotType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.SlotType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.SlotType.displayName = 'proto.suki.pb.ingester.SlotType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedSlotType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedSlotType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedSlotType.displayName = 'proto.suki.pb.ingester.AddedSlotType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertSlotTypesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertSlotTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertSlotTypesRequest.displayName = 'proto.suki.pb.ingester.UpsertSlotTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertSlotTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertSlotTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertSlotTypesResponse.displayName = 'proto.suki.pb.ingester.UpsertSlotTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedSlotValueType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedSlotValueType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedSlotValueType.displayName = 'proto.suki.pb.ingester.AddedSlotValueType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.HealthCheckRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.HealthCheckRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.HealthCheckRequest.displayName = 'proto.suki.pb.ingester.HealthCheckRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.HealthCheckResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.HealthCheckResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.HealthCheckResponse.displayName = 'proto.suki.pb.ingester.HealthCheckResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertSlotValueTypesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertSlotValueTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertSlotValueTypesRequest.displayName = 'proto.suki.pb.ingester.UpsertSlotValueTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertSlotValueTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertSlotValueTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertSlotValueTypesResponse.displayName = 'proto.suki.pb.ingester.UpsertSlotValueTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.User.displayName = 'proto.suki.pb.ingester.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedUser.displayName = 'proto.suki.pb.ingester.AddedUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertUsersRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertUsersRequest.displayName = 'proto.suki.pb.ingester.UpsertUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertUsersResponse.displayName = 'proto.suki.pb.ingester.UpsertUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetUsersRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetUsersRequest.displayName = 'proto.suki.pb.ingester.GetUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetUsersResponse.displayName = 'proto.suki.pb.ingester.GetUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.Group = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.Group, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.Group.displayName = 'proto.suki.pb.ingester.Group';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.NormalizedGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.NormalizedGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.NormalizedGroup.displayName = 'proto.suki.pb.ingester.NormalizedGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedGroup.displayName = 'proto.suki.pb.ingester.AddedGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertGroupsRequest.displayName = 'proto.suki.pb.ingester.UpsertGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertGroupsResponse.displayName = 'proto.suki.pb.ingester.UpsertGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertNormalizedGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.displayName = 'proto.suki.pb.ingester.UpsertNormalizedGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertNormalizedGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.displayName = 'proto.suki.pb.ingester.UpsertNormalizedGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetGroupsRequest.displayName = 'proto.suki.pb.ingester.GetGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetGroupsResponse.displayName = 'proto.suki.pb.ingester.GetGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetNormalizedGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetNormalizedGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetNormalizedGroupsRequest.displayName = 'proto.suki.pb.ingester.GetNormalizedGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetNormalizedGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetNormalizedGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetNormalizedGroupsResponse.displayName = 'proto.suki.pb.ingester.GetNormalizedGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetNotNormalizedGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.displayName = 'proto.suki.pb.ingester.GetNotNormalizedGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetNotNormalizedGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.displayName = 'proto.suki.pb.ingester.GetNotNormalizedGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.Facility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.Facility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.Facility.displayName = 'proto.suki.pb.ingester.Facility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedFacility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedFacility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedFacility.displayName = 'proto.suki.pb.ingester.AddedFacility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertFacilitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertFacilitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertFacilitiesRequest.displayName = 'proto.suki.pb.ingester.UpsertFacilitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertFacilitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertFacilitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertFacilitiesResponse.displayName = 'proto.suki.pb.ingester.UpsertFacilitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetFacilitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetFacilitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetFacilitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetFacilitiesRequest.displayName = 'proto.suki.pb.ingester.GetFacilitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetFacilitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetFacilitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetFacilitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetFacilitiesResponse.displayName = 'proto.suki.pb.ingester.GetFacilitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.Contact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.Contact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.Contact.displayName = 'proto.suki.pb.ingester.Contact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedContact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedContact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedContact.displayName = 'proto.suki.pb.ingester.AddedContact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertContactsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertContactsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertContactsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertContactsRequest.displayName = 'proto.suki.pb.ingester.UpsertContactsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertContactsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertContactsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertContactsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertContactsResponse.displayName = 'proto.suki.pb.ingester.UpsertContactsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetContactsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetContactsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetContactsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetContactsRequest.displayName = 'proto.suki.pb.ingester.GetContactsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetContactsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetContactsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetContactsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetContactsResponse.displayName = 'proto.suki.pb.ingester.GetContactsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.APLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.APLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.APLocation.displayName = 'proto.suki.pb.ingester.APLocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedAPLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedAPLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedAPLocation.displayName = 'proto.suki.pb.ingester.AddedAPLocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertAPLocationsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertAPLocationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertAPLocationsRequest.displayName = 'proto.suki.pb.ingester.UpsertAPLocationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertAPLocationsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertAPLocationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertAPLocationsResponse.displayName = 'proto.suki.pb.ingester.UpsertAPLocationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetAPLocationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetAPLocationsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetAPLocationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetAPLocationsRequest.displayName = 'proto.suki.pb.ingester.GetAPLocationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetAPLocationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetAPLocationsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetAPLocationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetAPLocationsResponse.displayName = 'proto.suki.pb.ingester.GetAPLocationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.VoceraBuddy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.VoceraBuddy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.VoceraBuddy.displayName = 'proto.suki.pb.ingester.VoceraBuddy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedVoceraBuddy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedVoceraBuddy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedVoceraBuddy.displayName = 'proto.suki.pb.ingester.AddedVoceraBuddy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertVoceraBuddiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.displayName = 'proto.suki.pb.ingester.UpsertVoceraBuddiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertVoceraBuddiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.displayName = 'proto.suki.pb.ingester.UpsertVoceraBuddiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetVoceraBuddiesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetVoceraBuddiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetVoceraBuddiesRequest.displayName = 'proto.suki.pb.ingester.GetVoceraBuddiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetVoceraBuddiesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetVoceraBuddiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetVoceraBuddiesResponse.displayName = 'proto.suki.pb.ingester.GetVoceraBuddiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.OutsideBuddy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.OutsideBuddy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.OutsideBuddy.displayName = 'proto.suki.pb.ingester.OutsideBuddy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddedOutsideBuddy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddedOutsideBuddy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddedOutsideBuddy.displayName = 'proto.suki.pb.ingester.AddedOutsideBuddy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertOutsideBuddiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.displayName = 'proto.suki.pb.ingester.UpsertOutsideBuddiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.UpsertOutsideBuddiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.displayName = 'proto.suki.pb.ingester.UpsertOutsideBuddiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetOutsideBuddiesRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetOutsideBuddiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetOutsideBuddiesRequest.displayName = 'proto.suki.pb.ingester.GetOutsideBuddiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetOutsideBuddiesResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetOutsideBuddiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetOutsideBuddiesResponse.displayName = 'proto.suki.pb.ingester.GetOutsideBuddiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteFacilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteFacilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteFacilityRequest.displayName = 'proto.suki.pb.ingester.DeleteFacilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteGroupRequest.displayName = 'proto.suki.pb.ingester.DeleteGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteUserRequest.displayName = 'proto.suki.pb.ingester.DeleteUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteAPLocationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteAPLocationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteAPLocationRequest.displayName = 'proto.suki.pb.ingester.DeleteAPLocationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteContactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteContactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteContactRequest.displayName = 'proto.suki.pb.ingester.DeleteContactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteVoceraBuddyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteVoceraBuddyRequest.displayName = 'proto.suki.pb.ingester.DeleteVoceraBuddyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.DeleteOutsideBuddyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.DeleteOutsideBuddyRequest.displayName = 'proto.suki.pb.ingester.DeleteOutsideBuddyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AnalyticsTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AnalyticsTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AnalyticsTransaction.displayName = 'proto.suki.pb.ingester.AnalyticsTransaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.AddAnalyticsTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.AddAnalyticsTransactionRequest.displayName = 'proto.suki.pb.ingester.AddAnalyticsTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetAnalyticsTransactionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.displayName = 'proto.suki.pb.ingester.GetAnalyticsTransactionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.repeatedFields_, null);
};
goog.inherits(proto.suki.pb.ingester.GetAnalyticsTransactionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.displayName = 'proto.suki.pb.ingester.GetAnalyticsTransactionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.TableUpdatedTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.TableUpdatedTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.TableUpdatedTime.displayName = 'proto.suki.pb.ingester.TableUpdatedTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.suki.pb.ingester.GetDBMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.suki.pb.ingester.GetDBMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.suki.pb.ingester.GetDBMetadataResponse.displayName = 'proto.suki.pb.ingester.GetDBMetadataResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetProjectIdsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetProjectIdsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetProjectIdsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetProjectIdsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetProjectIdsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetProjectIdsResponse}
 */
proto.suki.pb.ingester.GetProjectIdsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetProjectIdsResponse;
  return proto.suki.pb.ingester.GetProjectIdsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetProjectIdsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetProjectIdsResponse}
 */
proto.suki.pb.ingester.GetProjectIdsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetProjectIdsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetProjectIdsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetProjectIdsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetProjectIdsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetProjectIdsResponse.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetProjectIdsResponse} returns this
 */
proto.suki.pb.ingester.GetProjectIdsResponse.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetProjectIdsResponse} returns this
 */
proto.suki.pb.ingester.GetProjectIdsResponse.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetProjectIdsResponse} returns this
 */
proto.suki.pb.ingester.GetProjectIdsResponse.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.Intent.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.Intent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.Intent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Intent.toObject = function(includeInstance, msg) {
  var f, obj = {
    intentType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numSlotTypes: jspb.Message.getFieldWithDefault(msg, 2, 0),
    slotTypes: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mandatorySlots: jspb.Message.getFieldWithDefault(msg, 4, ""),
    multipleValuesAllowedForSlots: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.Intent}
 */
proto.suki.pb.ingester.Intent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.Intent;
  return proto.suki.pb.ingester.Intent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.Intent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.Intent}
 */
proto.suki.pb.ingester.Intent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntentType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumSlotTypes(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotTypes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMandatorySlots(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMultipleValuesAllowedForSlots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.Intent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.Intent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.Intent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Intent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntentType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumSlotTypes();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSlotTypes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMandatorySlots();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMultipleValuesAllowedForSlots();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string intent_type = 1;
 * @return {string}
 */
proto.suki.pb.ingester.Intent.prototype.getIntentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Intent} returns this
 */
proto.suki.pb.ingester.Intent.prototype.setIntentType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 num_slot_types = 2;
 * @return {number}
 */
proto.suki.pb.ingester.Intent.prototype.getNumSlotTypes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.Intent} returns this
 */
proto.suki.pb.ingester.Intent.prototype.setNumSlotTypes = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string slot_types = 3;
 * @return {string}
 */
proto.suki.pb.ingester.Intent.prototype.getSlotTypes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Intent} returns this
 */
proto.suki.pb.ingester.Intent.prototype.setSlotTypes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mandatory_slots = 4;
 * @return {string}
 */
proto.suki.pb.ingester.Intent.prototype.getMandatorySlots = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Intent} returns this
 */
proto.suki.pb.ingester.Intent.prototype.setMandatorySlots = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string multiple_values_allowed_for_slots = 5;
 * @return {string}
 */
proto.suki.pb.ingester.Intent.prototype.getMultipleValuesAllowedForSlots = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Intent} returns this
 */
proto.suki.pb.ingester.Intent.prototype.setMultipleValuesAllowedForSlots = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedIntent.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedIntent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedIntent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedIntent.toObject = function(includeInstance, msg) {
  var f, obj = {
    intent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    error: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedIntent}
 */
proto.suki.pb.ingester.AddedIntent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedIntent;
  return proto.suki.pb.ingester.AddedIntent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedIntent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedIntent}
 */
proto.suki.pb.ingester.AddedIntent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntent(value);
      break;
    case 2:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedIntent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedIntent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedIntent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedIntent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string intent = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedIntent.prototype.getIntent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedIntent} returns this
 */
proto.suki.pb.ingester.AddedIntent.prototype.setIntent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AddStatus status = 2;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedIntent.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedIntent} returns this
 */
proto.suki.pb.ingester.AddedIntent.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string error = 3;
 * @return {string}
 */
proto.suki.pb.ingester.AddedIntent.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedIntent} returns this
 */
proto.suki.pb.ingester.AddedIntent.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertIntentsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertIntentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertIntentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertIntentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    intentsList: jspb.Message.toObjectList(msg.getIntentsList(),
    proto.suki.pb.ingester.Intent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertIntentsRequest}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertIntentsRequest;
  return proto.suki.pb.ingester.UpsertIntentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertIntentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertIntentsRequest}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.Intent;
      reader.readMessage(value,proto.suki.pb.ingester.Intent.deserializeBinaryFromReader);
      msg.addIntents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertIntentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertIntentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertIntentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.Intent.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_user_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertIntentsRequest} returns this
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Intent intents = 2;
 * @return {!Array<!proto.suki.pb.ingester.Intent>}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.getIntentsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Intent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Intent, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Intent>} value
 * @return {!proto.suki.pb.ingester.UpsertIntentsRequest} returns this
*/
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.setIntentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.Intent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Intent}
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.addIntents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.Intent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertIntentsRequest} returns this
 */
proto.suki.pb.ingester.UpsertIntentsRequest.prototype.clearIntentsList = function() {
  return this.setIntentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertIntentsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertIntentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertIntentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertIntentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedIntentsList: jspb.Message.toObjectList(msg.getAddedIntentsList(),
    proto.suki.pb.ingester.AddedIntent.toObject, includeInstance),
    errorIntentsList: jspb.Message.toObjectList(msg.getErrorIntentsList(),
    proto.suki.pb.ingester.AddedIntent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertIntentsResponse}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertIntentsResponse;
  return proto.suki.pb.ingester.UpsertIntentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertIntentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertIntentsResponse}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedIntent;
      reader.readMessage(value,proto.suki.pb.ingester.AddedIntent.deserializeBinaryFromReader);
      msg.addAddedIntents(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedIntent;
      reader.readMessage(value,proto.suki.pb.ingester.AddedIntent.deserializeBinaryFromReader);
      msg.addErrorIntents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertIntentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertIntentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertIntentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedIntentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedIntent.serializeBinaryToWriter
    );
  }
  f = message.getErrorIntentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedIntent.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedIntent added_intents = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedIntent>}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.getAddedIntentsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedIntent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedIntent, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedIntent>} value
 * @return {!proto.suki.pb.ingester.UpsertIntentsResponse} returns this
*/
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.setAddedIntentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedIntent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedIntent}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.addAddedIntents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedIntent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertIntentsResponse} returns this
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.clearAddedIntentsList = function() {
  return this.setAddedIntentsList([]);
};


/**
 * repeated AddedIntent error_intents = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedIntent>}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.getErrorIntentsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedIntent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedIntent, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedIntent>} value
 * @return {!proto.suki.pb.ingester.UpsertIntentsResponse} returns this
*/
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.setErrorIntentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedIntent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedIntent}
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.addErrorIntents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedIntent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertIntentsResponse} returns this
 */
proto.suki.pb.ingester.UpsertIntentsResponse.prototype.clearErrorIntentsList = function() {
  return this.setErrorIntentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.SlotType.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.SlotType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.SlotType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.SlotType.toObject = function(includeInstance, msg) {
  var f, obj = {
    slotType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotValueType: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.SlotType}
 */
proto.suki.pb.ingester.SlotType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.SlotType;
  return proto.suki.pb.ingester.SlotType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.SlotType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.SlotType}
 */
proto.suki.pb.ingester.SlotType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotValueType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.SlotType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.SlotType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.SlotType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.SlotType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlotType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotValueType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string slot_type = 1;
 * @return {string}
 */
proto.suki.pb.ingester.SlotType.prototype.getSlotType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.SlotType} returns this
 */
proto.suki.pb.ingester.SlotType.prototype.setSlotType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slot_value_type = 2;
 * @return {string}
 */
proto.suki.pb.ingester.SlotType.prototype.getSlotValueType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.SlotType} returns this
 */
proto.suki.pb.ingester.SlotType.prototype.setSlotValueType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedSlotType.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedSlotType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedSlotType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedSlotType.toObject = function(includeInstance, msg) {
  var f, obj = {
    slotType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    error: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedSlotType}
 */
proto.suki.pb.ingester.AddedSlotType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedSlotType;
  return proto.suki.pb.ingester.AddedSlotType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedSlotType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedSlotType}
 */
proto.suki.pb.ingester.AddedSlotType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotType(value);
      break;
    case 2:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedSlotType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedSlotType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedSlotType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedSlotType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlotType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string slot_type = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedSlotType.prototype.getSlotType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedSlotType} returns this
 */
proto.suki.pb.ingester.AddedSlotType.prototype.setSlotType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AddStatus status = 2;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedSlotType.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedSlotType} returns this
 */
proto.suki.pb.ingester.AddedSlotType.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string error = 3;
 * @return {string}
 */
proto.suki.pb.ingester.AddedSlotType.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedSlotType} returns this
 */
proto.suki.pb.ingester.AddedSlotType.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertSlotTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotTypesList: jspb.Message.toObjectList(msg.getSlotTypesList(),
    proto.suki.pb.ingester.SlotType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesRequest}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertSlotTypesRequest;
  return proto.suki.pb.ingester.UpsertSlotTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesRequest}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.SlotType;
      reader.readMessage(value,proto.suki.pb.ingester.SlotType.deserializeBinaryFromReader);
      msg.addSlotTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertSlotTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.SlotType.serializeBinaryToWriter
    );
  }
};


/**
 * optional string request_user_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesRequest} returns this
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SlotType slot_types = 2;
 * @return {!Array<!proto.suki.pb.ingester.SlotType>}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.getSlotTypesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.SlotType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.SlotType, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.SlotType>} value
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesRequest} returns this
*/
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.setSlotTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.SlotType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.SlotType}
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.addSlotTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.SlotType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesRequest} returns this
 */
proto.suki.pb.ingester.UpsertSlotTypesRequest.prototype.clearSlotTypesList = function() {
  return this.setSlotTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertSlotTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedSlotTypesList: jspb.Message.toObjectList(msg.getAddedSlotTypesList(),
    proto.suki.pb.ingester.AddedSlotType.toObject, includeInstance),
    errorSlotTypesList: jspb.Message.toObjectList(msg.getErrorSlotTypesList(),
    proto.suki.pb.ingester.AddedIntent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesResponse}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertSlotTypesResponse;
  return proto.suki.pb.ingester.UpsertSlotTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesResponse}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedSlotType;
      reader.readMessage(value,proto.suki.pb.ingester.AddedSlotType.deserializeBinaryFromReader);
      msg.addAddedSlotTypes(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedIntent;
      reader.readMessage(value,proto.suki.pb.ingester.AddedIntent.deserializeBinaryFromReader);
      msg.addErrorSlotTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertSlotTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedSlotTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedSlotType.serializeBinaryToWriter
    );
  }
  f = message.getErrorSlotTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedIntent.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedSlotType added_slot_types = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedSlotType>}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.getAddedSlotTypesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedSlotType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedSlotType, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedSlotType>} value
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesResponse} returns this
*/
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.setAddedSlotTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedSlotType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedSlotType}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.addAddedSlotTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedSlotType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesResponse} returns this
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.clearAddedSlotTypesList = function() {
  return this.setAddedSlotTypesList([]);
};


/**
 * repeated AddedIntent error_slot_types = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedIntent>}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.getErrorSlotTypesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedIntent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedIntent, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedIntent>} value
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesResponse} returns this
*/
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.setErrorSlotTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedIntent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedIntent}
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.addErrorSlotTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedIntent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertSlotTypesResponse} returns this
 */
proto.suki.pb.ingester.UpsertSlotTypesResponse.prototype.clearErrorSlotTypesList = function() {
  return this.setErrorSlotTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedSlotValueType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedSlotValueType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedSlotValueType.toObject = function(includeInstance, msg) {
  var f, obj = {
    slotValueType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    error: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedSlotValueType}
 */
proto.suki.pb.ingester.AddedSlotValueType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedSlotValueType;
  return proto.suki.pb.ingester.AddedSlotValueType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedSlotValueType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedSlotValueType}
 */
proto.suki.pb.ingester.AddedSlotValueType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotValueType(value);
      break;
    case 2:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedSlotValueType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedSlotValueType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedSlotValueType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlotValueType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string slot_value_type = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.getSlotValueType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedSlotValueType} returns this
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.setSlotValueType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AddStatus status = 2;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedSlotValueType} returns this
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string error = 3;
 * @return {string}
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedSlotValueType} returns this
 */
proto.suki.pb.ingester.AddedSlotValueType.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.HealthCheckRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.HealthCheckRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.HealthCheckRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.HealthCheckRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jwtToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shallow: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.HealthCheckRequest}
 */
proto.suki.pb.ingester.HealthCheckRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.HealthCheckRequest;
  return proto.suki.pb.ingester.HealthCheckRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.HealthCheckRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.HealthCheckRequest}
 */
proto.suki.pb.ingester.HealthCheckRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJwtToken(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShallow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.HealthCheckRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.HealthCheckRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.HealthCheckRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.HealthCheckRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJwtToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShallow();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string jwt_token = 1;
 * @return {string}
 */
proto.suki.pb.ingester.HealthCheckRequest.prototype.getJwtToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.HealthCheckRequest} returns this
 */
proto.suki.pb.ingester.HealthCheckRequest.prototype.setJwtToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool shallow = 2;
 * @return {boolean}
 */
proto.suki.pb.ingester.HealthCheckRequest.prototype.getShallow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.suki.pb.ingester.HealthCheckRequest} returns this
 */
proto.suki.pb.ingester.HealthCheckRequest.prototype.setShallow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.HealthCheckResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.HealthCheckResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.HealthCheckResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.HealthCheckResponse}
 */
proto.suki.pb.ingester.HealthCheckResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.HealthCheckResponse;
  return proto.suki.pb.ingester.HealthCheckResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.HealthCheckResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.HealthCheckResponse}
 */
proto.suki.pb.ingester.HealthCheckResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.HealthCheckResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.HealthCheckResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.HealthCheckResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string version = 1;
 * @return {string}
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.HealthCheckResponse} returns this
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.HealthCheckResponse} returns this
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.HealthCheckResponse} returns this
 */
proto.suki.pb.ingester.HealthCheckResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertSlotValueTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotValueTypesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertSlotValueTypesRequest;
  return proto.suki.pb.ingester.UpsertSlotValueTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addSlotValueTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertSlotValueTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotValueTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string request_user_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} returns this
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string slot_value_types = 2;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.getSlotValueTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} returns this
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.setSlotValueTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} returns this
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.addSlotValueTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} returns this
 */
proto.suki.pb.ingester.UpsertSlotValueTypesRequest.prototype.clearSlotValueTypesList = function() {
  return this.setSlotValueTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertSlotValueTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedSlotValueTypesList: jspb.Message.toObjectList(msg.getAddedSlotValueTypesList(),
    proto.suki.pb.ingester.AddedSlotValueType.toObject, includeInstance),
    errorSlotValueTypesList: jspb.Message.toObjectList(msg.getErrorSlotValueTypesList(),
    proto.suki.pb.ingester.AddedIntent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertSlotValueTypesResponse;
  return proto.suki.pb.ingester.UpsertSlotValueTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedSlotValueType;
      reader.readMessage(value,proto.suki.pb.ingester.AddedSlotValueType.deserializeBinaryFromReader);
      msg.addAddedSlotValueTypes(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedIntent;
      reader.readMessage(value,proto.suki.pb.ingester.AddedIntent.deserializeBinaryFromReader);
      msg.addErrorSlotValueTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertSlotValueTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedSlotValueTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedSlotValueType.serializeBinaryToWriter
    );
  }
  f = message.getErrorSlotValueTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedIntent.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedSlotValueType added_slot_value_types = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedSlotValueType>}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.getAddedSlotValueTypesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedSlotValueType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedSlotValueType, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedSlotValueType>} value
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} returns this
*/
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.setAddedSlotValueTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedSlotValueType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedSlotValueType}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.addAddedSlotValueTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedSlotValueType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} returns this
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.clearAddedSlotValueTypesList = function() {
  return this.setAddedSlotValueTypesList([]);
};


/**
 * repeated AddedIntent error_slot_value_types = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedIntent>}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.getErrorSlotValueTypesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedIntent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedIntent, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedIntent>} value
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} returns this
*/
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.setErrorSlotValueTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedIntent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedIntent}
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.addErrorSlotValueTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedIntent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertSlotValueTypesResponse} returns this
 */
proto.suki.pb.ingester.UpsertSlotValueTypesResponse.prototype.clearErrorSlotValueTypesList = function() {
  return this.setErrorSlotValueTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.User.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    departmentIds: jspb.Message.getFieldWithDefault(msg, 6, ""),
    alternativeSpokenName1: jspb.Message.getFieldWithDefault(msg, 7, ""),
    alternativeSpokenName2: jspb.Message.getFieldWithDefault(msg, 8, ""),
    alternativeSpokenName3: jspb.Message.getFieldWithDefault(msg, 9, ""),
    identifyingPhrase: jspb.Message.getFieldWithDefault(msg, 10, ""),
    doctorPrefix: jspb.Message.getFieldWithDefault(msg, 11, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    firstNameNormalized: jspb.Message.getFieldWithDefault(msg, 15, ""),
    lastNameNormalized: jspb.Message.getFieldWithDefault(msg, 16, ""),
    alternativeSpokenName1Normalized: jspb.Message.getFieldWithDefault(msg, 17, ""),
    alternativeSpokenName2Normalized: jspb.Message.getFieldWithDefault(msg, 18, ""),
    alternativeSpokenName3Normalized: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.User}
 */
proto.suki.pb.ingester.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.User;
  return proto.suki.pb.ingester.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.User}
 */
proto.suki.pb.ingester.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartmentIds(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName1(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName2(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName3(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifyingPhrase(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDoctorPrefix(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstNameNormalized(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastNameNormalized(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName1Normalized(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName2Normalized(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName3Normalized(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDepartmentIds();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAlternativeSpokenName1();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAlternativeSpokenName2();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAlternativeSpokenName3();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIdentifyingPhrase();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDoctorPrefix();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFirstNameNormalized();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getLastNameNormalized();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAlternativeSpokenName1Normalized();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAlternativeSpokenName2Normalized();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAlternativeSpokenName3Normalized();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string first_name = 4;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string last_name = 5;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string department_ids = 6;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getDepartmentIds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setDepartmentIds = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string alternative_spoken_name1 = 7;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getAlternativeSpokenName1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setAlternativeSpokenName1 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string alternative_spoken_name2 = 8;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getAlternativeSpokenName2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setAlternativeSpokenName2 = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string alternative_spoken_name3 = 9;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getAlternativeSpokenName3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setAlternativeSpokenName3 = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string identifying_phrase = 10;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getIdentifyingPhrase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setIdentifyingPhrase = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string doctor_prefix = 11;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getDoctorPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setDoctorPrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.User.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.User} returns this
*/
proto.suki.pb.ingester.User.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.User.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.User.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.User} returns this
*/
proto.suki.pb.ingester.User.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.User.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.User.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.User} returns this
*/
proto.suki.pb.ingester.User.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.User.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string first_name_normalized = 15;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getFirstNameNormalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setFirstNameNormalized = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string last_name_normalized = 16;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getLastNameNormalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setLastNameNormalized = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string alternative_spoken_name1_normalized = 17;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getAlternativeSpokenName1Normalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setAlternativeSpokenName1Normalized = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string alternative_spoken_name2_normalized = 18;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getAlternativeSpokenName2Normalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setAlternativeSpokenName2Normalized = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string alternative_spoken_name3_normalized = 19;
 * @return {string}
 */
proto.suki.pb.ingester.User.prototype.getAlternativeSpokenName3Normalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.User} returns this
 */
proto.suki.pb.ingester.User.prototype.setAlternativeSpokenName3Normalized = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedUser.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedUser}
 */
proto.suki.pb.ingester.AddedUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedUser;
  return proto.suki.pb.ingester.AddedUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedUser}
 */
proto.suki.pb.ingester.AddedUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedUser.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedUser} returns this
 */
proto.suki.pb.ingester.AddedUser.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedUser.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedUser} returns this
 */
proto.suki.pb.ingester.AddedUser.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddStatus status = 3;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedUser.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedUser} returns this
 */
proto.suki.pb.ingester.AddedUser.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AddedUser.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedUser} returns this
 */
proto.suki.pb.ingester.AddedUser.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertUsersRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.suki.pb.ingester.User.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertUsersRequest}
 */
proto.suki.pb.ingester.UpsertUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertUsersRequest;
  return proto.suki.pb.ingester.UpsertUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertUsersRequest}
 */
proto.suki.pb.ingester.UpsertUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.User;
      reader.readMessage(value,proto.suki.pb.ingester.User.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertUsersRequest} returns this
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertUsersRequest} returns this
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated User users = 3;
 * @return {!Array<!proto.suki.pb.ingester.User>}
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.User>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.User, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.User>} value
 * @return {!proto.suki.pb.ingester.UpsertUsersRequest} returns this
*/
proto.suki.pb.ingester.UpsertUsersRequest.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.User=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.User}
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.User, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertUsersRequest} returns this
 */
proto.suki.pb.ingester.UpsertUsersRequest.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertUsersResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedUsersList: jspb.Message.toObjectList(msg.getAddedUsersList(),
    proto.suki.pb.ingester.AddedUser.toObject, includeInstance),
    errorUsersList: jspb.Message.toObjectList(msg.getErrorUsersList(),
    proto.suki.pb.ingester.AddedUser.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertUsersResponse}
 */
proto.suki.pb.ingester.UpsertUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertUsersResponse;
  return proto.suki.pb.ingester.UpsertUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertUsersResponse}
 */
proto.suki.pb.ingester.UpsertUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedUser;
      reader.readMessage(value,proto.suki.pb.ingester.AddedUser.deserializeBinaryFromReader);
      msg.addAddedUsers(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedUser;
      reader.readMessage(value,proto.suki.pb.ingester.AddedUser.deserializeBinaryFromReader);
      msg.addErrorUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedUser.serializeBinaryToWriter
    );
  }
  f = message.getErrorUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedUser.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedUser added_users = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedUser>}
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.getAddedUsersList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedUser, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedUser>} value
 * @return {!proto.suki.pb.ingester.UpsertUsersResponse} returns this
*/
proto.suki.pb.ingester.UpsertUsersResponse.prototype.setAddedUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedUser}
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.addAddedUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertUsersResponse} returns this
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.clearAddedUsersList = function() {
  return this.setAddedUsersList([]);
};


/**
 * repeated AddedUser error_users = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedUser>}
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.getErrorUsersList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedUser, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedUser>} value
 * @return {!proto.suki.pb.ingester.UpsertUsersResponse} returns this
*/
proto.suki.pb.ingester.UpsertUsersResponse.prototype.setErrorUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedUser}
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.addErrorUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertUsersResponse} returns this
 */
proto.suki.pb.ingester.UpsertUsersResponse.prototype.clearErrorUsersList = function() {
  return this.setErrorUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetUsersRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetUsersRequest}
 */
proto.suki.pb.ingester.GetUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetUsersRequest;
  return proto.suki.pb.ingester.GetUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetUsersRequest}
 */
proto.suki.pb.ingester.GetUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string user_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated string facility_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
*/
proto.suki.pb.ingester.GetUsersRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetUsersRequest} returns this
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetUsersRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetUsersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.suki.pb.ingester.User.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetUsersResponse}
 */
proto.suki.pb.ingester.GetUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetUsersResponse;
  return proto.suki.pb.ingester.GetUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetUsersResponse}
 */
proto.suki.pb.ingester.GetUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.User;
      reader.readMessage(value,proto.suki.pb.ingester.User.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.User.serializeBinaryToWriter
    );
  }
};


/**
 * repeated User users = 1;
 * @return {!Array<!proto.suki.pb.ingester.User>}
 */
proto.suki.pb.ingester.GetUsersResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.User>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.User, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.User>} value
 * @return {!proto.suki.pb.ingester.GetUsersResponse} returns this
*/
proto.suki.pb.ingester.GetUsersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.User=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.User}
 */
proto.suki.pb.ingester.GetUsersResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.User, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetUsersResponse} returns this
 */
proto.suki.pb.ingester.GetUsersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.Group.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.Group.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.Group} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Group.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    groupName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    memberNameSingular: jspb.Message.getFieldWithDefault(msg, 5, ""),
    memberNamePlural: jspb.Message.getFieldWithDefault(msg, 6, ""),
    alternativeSpokenName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.Group}
 */
proto.suki.pb.ingester.Group.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.Group;
  return proto.suki.pb.ingester.Group.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.Group} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.Group}
 */
proto.suki.pb.ingester.Group.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNameSingular(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNamePlural(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.Group.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.Group.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.Group} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Group.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMemberNameSingular();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMemberNamePlural();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAlternativeSpokenName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group_name = 4;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string member_name_singular = 5;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getMemberNameSingular = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setMemberNameSingular = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string member_name_plural = 6;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getMemberNamePlural = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setMemberNamePlural = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string alternative_spoken_name = 7;
 * @return {string}
 */
proto.suki.pb.ingester.Group.prototype.getAlternativeSpokenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.setAlternativeSpokenName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Group.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Group} returns this
*/
proto.suki.pb.ingester.Group.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Group.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Group.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Group} returns this
*/
proto.suki.pb.ingester.Group.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Group.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Group.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Group} returns this
*/
proto.suki.pb.ingester.Group.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Group} returns this
 */
proto.suki.pb.ingester.Group.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Group.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.NormalizedGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.NormalizedGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.NormalizedGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    groupName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    groupNameNormalized: jspb.Message.getFieldWithDefault(msg, 5, ""),
    memberNameSingular: jspb.Message.getFieldWithDefault(msg, 6, ""),
    memberNameSingularNormalized: jspb.Message.getFieldWithDefault(msg, 7, ""),
    memberNamePlural: jspb.Message.getFieldWithDefault(msg, 8, ""),
    memberNamePluralNormalized: jspb.Message.getFieldWithDefault(msg, 9, ""),
    alternativeSpokenName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    alternativeSpokenNameNormalized: jspb.Message.getFieldWithDefault(msg, 11, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.NormalizedGroup}
 */
proto.suki.pb.ingester.NormalizedGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.NormalizedGroup;
  return proto.suki.pb.ingester.NormalizedGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.NormalizedGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.NormalizedGroup}
 */
proto.suki.pb.ingester.NormalizedGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupNameNormalized(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNameSingular(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNameSingularNormalized(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNamePlural(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNamePluralNormalized(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenNameNormalized(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.NormalizedGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.NormalizedGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.NormalizedGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGroupNameNormalized();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMemberNameSingular();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMemberNameSingularNormalized();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMemberNamePlural();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMemberNamePluralNormalized();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAlternativeSpokenName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAlternativeSpokenNameNormalized();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string group_name = 4;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string group_name_normalized = 5;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getGroupNameNormalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setGroupNameNormalized = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string member_name_singular = 6;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getMemberNameSingular = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setMemberNameSingular = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string member_name_singular_normalized = 7;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getMemberNameSingularNormalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setMemberNameSingularNormalized = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string member_name_plural = 8;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getMemberNamePlural = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setMemberNamePlural = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string member_name_plural_normalized = 9;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getMemberNamePluralNormalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setMemberNamePluralNormalized = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string alternative_spoken_name = 10;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getAlternativeSpokenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setAlternativeSpokenName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string alternative_spoken_name_normalized = 11;
 * @return {string}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getAlternativeSpokenNameNormalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.setAlternativeSpokenNameNormalized = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
*/
proto.suki.pb.ingester.NormalizedGroup.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
*/
proto.suki.pb.ingester.NormalizedGroup.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
*/
proto.suki.pb.ingester.NormalizedGroup.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.NormalizedGroup} returns this
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.NormalizedGroup.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedGroup}
 */
proto.suki.pb.ingester.AddedGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedGroup;
  return proto.suki.pb.ingester.AddedGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedGroup}
 */
proto.suki.pb.ingester.AddedGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedGroup.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedGroup} returns this
 */
proto.suki.pb.ingester.AddedGroup.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedGroup.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedGroup} returns this
 */
proto.suki.pb.ingester.AddedGroup.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddStatus status = 3;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedGroup.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedGroup} returns this
 */
proto.suki.pb.ingester.AddedGroup.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AddedGroup.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedGroup} returns this
 */
proto.suki.pb.ingester.AddedGroup.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertGroupsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.suki.pb.ingester.Group.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertGroupsRequest}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertGroupsRequest;
  return proto.suki.pb.ingester.UpsertGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertGroupsRequest}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.Group;
      reader.readMessage(value,proto.suki.pb.ingester.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.Group.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertGroupsRequest} returns this
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertGroupsRequest} returns this
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Group groups = 3;
 * @return {!Array<!proto.suki.pb.ingester.Group>}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Group, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Group>} value
 * @return {!proto.suki.pb.ingester.UpsertGroupsRequest} returns this
*/
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Group}
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertGroupsRequest} returns this
 */
proto.suki.pb.ingester.UpsertGroupsRequest.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertGroupsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedGroupsList: jspb.Message.toObjectList(msg.getAddedGroupsList(),
    proto.suki.pb.ingester.AddedGroup.toObject, includeInstance),
    errorGroupsList: jspb.Message.toObjectList(msg.getErrorGroupsList(),
    proto.suki.pb.ingester.AddedGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertGroupsResponse}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertGroupsResponse;
  return proto.suki.pb.ingester.UpsertGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertGroupsResponse}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedGroup;
      reader.readMessage(value,proto.suki.pb.ingester.AddedGroup.deserializeBinaryFromReader);
      msg.addAddedGroups(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedGroup;
      reader.readMessage(value,proto.suki.pb.ingester.AddedGroup.deserializeBinaryFromReader);
      msg.addErrorGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedGroup.serializeBinaryToWriter
    );
  }
  f = message.getErrorGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedGroup added_groups = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedGroup>}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.getAddedGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedGroup, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedGroup>} value
 * @return {!proto.suki.pb.ingester.UpsertGroupsResponse} returns this
*/
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.setAddedGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedGroup}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.addAddedGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertGroupsResponse} returns this
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.clearAddedGroupsList = function() {
  return this.setAddedGroupsList([]);
};


/**
 * repeated AddedGroup error_groups = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedGroup>}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.getErrorGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedGroup, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedGroup>} value
 * @return {!proto.suki.pb.ingester.UpsertGroupsResponse} returns this
*/
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.setErrorGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedGroup}
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.addErrorGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertGroupsResponse} returns this
 */
proto.suki.pb.ingester.UpsertGroupsResponse.prototype.clearErrorGroupsList = function() {
  return this.setErrorGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.suki.pb.ingester.NormalizedGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertNormalizedGroupsRequest;
  return proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.NormalizedGroup;
      reader.readMessage(value,proto.suki.pb.ingester.NormalizedGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.NormalizedGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated NormalizedGroup groups = 3;
 * @return {!Array<!proto.suki.pb.ingester.NormalizedGroup>}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.NormalizedGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.NormalizedGroup, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.NormalizedGroup>} value
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} returns this
*/
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.NormalizedGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.NormalizedGroup}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.NormalizedGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsRequest.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedGroupsList: jspb.Message.toObjectList(msg.getAddedGroupsList(),
    proto.suki.pb.ingester.AddedGroup.toObject, includeInstance),
    errorGroupsList: jspb.Message.toObjectList(msg.getErrorGroupsList(),
    proto.suki.pb.ingester.AddedGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertNormalizedGroupsResponse;
  return proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedGroup;
      reader.readMessage(value,proto.suki.pb.ingester.AddedGroup.deserializeBinaryFromReader);
      msg.addAddedGroups(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedGroup;
      reader.readMessage(value,proto.suki.pb.ingester.AddedGroup.deserializeBinaryFromReader);
      msg.addErrorGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedGroup.serializeBinaryToWriter
    );
  }
  f = message.getErrorGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedGroup added_groups = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedGroup>}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.getAddedGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedGroup, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedGroup>} value
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} returns this
*/
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.setAddedGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedGroup}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.addAddedGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} returns this
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.clearAddedGroupsList = function() {
  return this.setAddedGroupsList([]);
};


/**
 * repeated AddedGroup error_groups = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedGroup>}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.getErrorGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedGroup, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedGroup>} value
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} returns this
*/
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.setErrorGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedGroup}
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.addErrorGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse} returns this
 */
proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.prototype.clearErrorGroupsList = function() {
  return this.setErrorGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetGroupsRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetGroupsRequest}
 */
proto.suki.pb.ingester.GetGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetGroupsRequest;
  return proto.suki.pb.ingester.GetGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetGroupsRequest}
 */
proto.suki.pb.ingester.GetGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroupIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string group_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.getGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.setGroupIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.addGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.clearGroupIdsList = function() {
  return this.setGroupIdsList([]);
};


/**
 * repeated string facility_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
*/
proto.suki.pb.ingester.GetGroupsRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetGroupsRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.suki.pb.ingester.Group.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetGroupsResponse}
 */
proto.suki.pb.ingester.GetGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetGroupsResponse;
  return proto.suki.pb.ingester.GetGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetGroupsResponse}
 */
proto.suki.pb.ingester.GetGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.Group;
      reader.readMessage(value,proto.suki.pb.ingester.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.Group.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Group groups = 1;
 * @return {!Array<!proto.suki.pb.ingester.Group>}
 */
proto.suki.pb.ingester.GetGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Group, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Group>} value
 * @return {!proto.suki.pb.ingester.GetGroupsResponse} returns this
*/
proto.suki.pb.ingester.GetGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Group}
 */
proto.suki.pb.ingester.GetGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetGroupsResponse} returns this
 */
proto.suki.pb.ingester.GetGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetNormalizedGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetNormalizedGroupsRequest;
  return proto.suki.pb.ingester.GetNormalizedGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroupIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetNormalizedGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string group_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.getGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.setGroupIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.addGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.clearGroupIdsList = function() {
  return this.setGroupIdsList([]);
};


/**
 * repeated string facility_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
*/
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetNormalizedGroupsRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetNormalizedGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.suki.pb.ingester.NormalizedGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsResponse}
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetNormalizedGroupsResponse;
  return proto.suki.pb.ingester.GetNormalizedGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsResponse}
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.NormalizedGroup;
      reader.readMessage(value,proto.suki.pb.ingester.NormalizedGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetNormalizedGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.NormalizedGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NormalizedGroup groups = 1;
 * @return {!Array<!proto.suki.pb.ingester.NormalizedGroup>}
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.NormalizedGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.NormalizedGroup, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.NormalizedGroup>} value
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsResponse} returns this
*/
proto.suki.pb.ingester.GetNormalizedGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.NormalizedGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.NormalizedGroup}
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.NormalizedGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetNormalizedGroupsResponse} returns this
 */
proto.suki.pb.ingester.GetNormalizedGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetNotNormalizedGroupsRequest;
  return proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroupIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string group_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.getGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.setGroupIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.addGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.clearGroupIdsList = function() {
  return this.setGroupIdsList([]);
};


/**
 * repeated string facility_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
*/
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.suki.pb.ingester.Group.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetNotNormalizedGroupsResponse;
  return proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.Group;
      reader.readMessage(value,proto.suki.pb.ingester.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.Group.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Group groups = 1;
 * @return {!Array<!proto.suki.pb.ingester.Group>}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Group, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Group>} value
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse} returns this
*/
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Group}
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse} returns this
 */
proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.Facility.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.Facility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.Facility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Facility.toObject = function(includeInstance, msg) {
  var f, obj = {
    facilityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    alternativeSpokenName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.Facility}
 */
proto.suki.pb.ingester.Facility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.Facility;
  return proto.suki.pb.ingester.Facility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.Facility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.Facility}
 */
proto.suki.pb.ingester.Facility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.Facility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.Facility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.Facility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Facility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAlternativeSpokenName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string facility_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.Facility.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.Facility.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_name = 3;
 * @return {string}
 */
proto.suki.pb.ingester.Facility.prototype.getFacilityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.setFacilityName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string alternative_spoken_name = 4;
 * @return {string}
 */
proto.suki.pb.ingester.Facility.prototype.getAlternativeSpokenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.setAlternativeSpokenName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Facility.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
*/
proto.suki.pb.ingester.Facility.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Facility.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Facility.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
*/
proto.suki.pb.ingester.Facility.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Facility.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Facility.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Facility} returns this
*/
proto.suki.pb.ingester.Facility.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Facility} returns this
 */
proto.suki.pb.ingester.Facility.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Facility.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedFacility.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedFacility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedFacility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedFacility.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedFacility}
 */
proto.suki.pb.ingester.AddedFacility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedFacility;
  return proto.suki.pb.ingester.AddedFacility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedFacility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedFacility}
 */
proto.suki.pb.ingester.AddedFacility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedFacility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedFacility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedFacility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedFacility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedFacility.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedFacility} returns this
 */
proto.suki.pb.ingester.AddedFacility.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedFacility.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedFacility} returns this
 */
proto.suki.pb.ingester.AddedFacility.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddStatus status = 3;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedFacility.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedFacility} returns this
 */
proto.suki.pb.ingester.AddedFacility.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AddedFacility.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedFacility} returns this
 */
proto.suki.pb.ingester.AddedFacility.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertFacilitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilitiesList: jspb.Message.toObjectList(msg.getFacilitiesList(),
    proto.suki.pb.ingester.Facility.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesRequest}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertFacilitiesRequest;
  return proto.suki.pb.ingester.UpsertFacilitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesRequest}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.Facility;
      reader.readMessage(value,proto.suki.pb.ingester.Facility.deserializeBinaryFromReader);
      msg.addFacilities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertFacilitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.Facility.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Facility facilities = 3;
 * @return {!Array<!proto.suki.pb.ingester.Facility>}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.getFacilitiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Facility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Facility, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Facility>} value
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesRequest} returns this
*/
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.setFacilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.Facility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Facility}
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.addFacilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.Facility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertFacilitiesRequest.prototype.clearFacilitiesList = function() {
  return this.setFacilitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertFacilitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedFacilitiesList: jspb.Message.toObjectList(msg.getAddedFacilitiesList(),
    proto.suki.pb.ingester.AddedFacility.toObject, includeInstance),
    errorFacilitiesList: jspb.Message.toObjectList(msg.getErrorFacilitiesList(),
    proto.suki.pb.ingester.AddedFacility.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesResponse}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertFacilitiesResponse;
  return proto.suki.pb.ingester.UpsertFacilitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesResponse}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedFacility;
      reader.readMessage(value,proto.suki.pb.ingester.AddedFacility.deserializeBinaryFromReader);
      msg.addAddedFacilities(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedFacility;
      reader.readMessage(value,proto.suki.pb.ingester.AddedFacility.deserializeBinaryFromReader);
      msg.addErrorFacilities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertFacilitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedFacilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedFacility.serializeBinaryToWriter
    );
  }
  f = message.getErrorFacilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedFacility.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedFacility added_facilities = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedFacility>}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.getAddedFacilitiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedFacility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedFacility, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedFacility>} value
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesResponse} returns this
*/
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.setAddedFacilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedFacility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedFacility}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.addAddedFacilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedFacility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesResponse} returns this
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.clearAddedFacilitiesList = function() {
  return this.setAddedFacilitiesList([]);
};


/**
 * repeated AddedFacility error_facilities = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedFacility>}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.getErrorFacilitiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedFacility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedFacility, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedFacility>} value
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesResponse} returns this
*/
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.setErrorFacilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedFacility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedFacility}
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.addErrorFacilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedFacility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertFacilitiesResponse} returns this
 */
proto.suki.pb.ingester.UpsertFacilitiesResponse.prototype.clearErrorFacilitiesList = function() {
  return this.setErrorFacilitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetFacilitiesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetFacilitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetFacilitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetFacilitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetFacilitiesRequest}
 */
proto.suki.pb.ingester.GetFacilitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetFacilitiesRequest;
  return proto.suki.pb.ingester.GetFacilitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetFacilitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetFacilitiesRequest}
 */
proto.suki.pb.ingester.GetFacilitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetFacilitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetFacilitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetFacilitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string facility_ids = 2;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetFacilitiesRequest} returns this
 */
proto.suki.pb.ingester.GetFacilitiesRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetFacilitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetFacilitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetFacilitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetFacilitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetFacilitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    facilitiesList: jspb.Message.toObjectList(msg.getFacilitiesList(),
    proto.suki.pb.ingester.Facility.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetFacilitiesResponse}
 */
proto.suki.pb.ingester.GetFacilitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetFacilitiesResponse;
  return proto.suki.pb.ingester.GetFacilitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetFacilitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetFacilitiesResponse}
 */
proto.suki.pb.ingester.GetFacilitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.Facility;
      reader.readMessage(value,proto.suki.pb.ingester.Facility.deserializeBinaryFromReader);
      msg.addFacilities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetFacilitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetFacilitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetFacilitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetFacilitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFacilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.Facility.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Facility facilities = 1;
 * @return {!Array<!proto.suki.pb.ingester.Facility>}
 */
proto.suki.pb.ingester.GetFacilitiesResponse.prototype.getFacilitiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Facility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Facility, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Facility>} value
 * @return {!proto.suki.pb.ingester.GetFacilitiesResponse} returns this
*/
proto.suki.pb.ingester.GetFacilitiesResponse.prototype.setFacilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.Facility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Facility}
 */
proto.suki.pb.ingester.GetFacilitiesResponse.prototype.addFacilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.Facility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetFacilitiesResponse} returns this
 */
proto.suki.pb.ingester.GetFacilitiesResponse.prototype.clearFacilitiesList = function() {
  return this.setFacilitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.Contact.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.Contact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.Contact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Contact.toObject = function(includeInstance, msg) {
  var f, obj = {
    contactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    alternativeSpokenName1: jspb.Message.getFieldWithDefault(msg, 6, ""),
    alternativeSpokenName2: jspb.Message.getFieldWithDefault(msg, 7, ""),
    alternativeSpokenName3: jspb.Message.getFieldWithDefault(msg, 8, ""),
    identifyingPhrase: jspb.Message.getFieldWithDefault(msg, 9, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.Contact}
 */
proto.suki.pb.ingester.Contact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.Contact;
  return proto.suki.pb.ingester.Contact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.Contact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.Contact}
 */
proto.suki.pb.ingester.Contact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName1(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName2(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName3(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifyingPhrase(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.Contact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.Contact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.Contact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.Contact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAlternativeSpokenName1();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAlternativeSpokenName2();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAlternativeSpokenName3();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIdentifyingPhrase();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string contact_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getContactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setContactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string first_name = 4;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string last_name = 5;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string alternative_spoken_name1 = 6;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getAlternativeSpokenName1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setAlternativeSpokenName1 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string alternative_spoken_name2 = 7;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getAlternativeSpokenName2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setAlternativeSpokenName2 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string alternative_spoken_name3 = 8;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getAlternativeSpokenName3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setAlternativeSpokenName3 = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string identifying_phrase = 9;
 * @return {string}
 */
proto.suki.pb.ingester.Contact.prototype.getIdentifyingPhrase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.setIdentifyingPhrase = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Contact.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
*/
proto.suki.pb.ingester.Contact.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Contact.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Contact.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
*/
proto.suki.pb.ingester.Contact.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Contact.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.Contact.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.Contact} returns this
*/
proto.suki.pb.ingester.Contact.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.Contact} returns this
 */
proto.suki.pb.ingester.Contact.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.Contact.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedContact.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedContact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedContact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedContact.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedContact}
 */
proto.suki.pb.ingester.AddedContact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedContact;
  return proto.suki.pb.ingester.AddedContact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedContact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedContact}
 */
proto.suki.pb.ingester.AddedContact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactId(value);
      break;
    case 3:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedContact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedContact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedContact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedContact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedContact.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedContact} returns this
 */
proto.suki.pb.ingester.AddedContact.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contact_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedContact.prototype.getContactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedContact} returns this
 */
proto.suki.pb.ingester.AddedContact.prototype.setContactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddStatus status = 3;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedContact.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedContact} returns this
 */
proto.suki.pb.ingester.AddedContact.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AddedContact.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedContact} returns this
 */
proto.suki.pb.ingester.AddedContact.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertContactsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertContactsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertContactsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertContactsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contactsList: jspb.Message.toObjectList(msg.getContactsList(),
    proto.suki.pb.ingester.Contact.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertContactsRequest}
 */
proto.suki.pb.ingester.UpsertContactsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertContactsRequest;
  return proto.suki.pb.ingester.UpsertContactsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertContactsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertContactsRequest}
 */
proto.suki.pb.ingester.UpsertContactsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.Contact;
      reader.readMessage(value,proto.suki.pb.ingester.Contact.deserializeBinaryFromReader);
      msg.addContacts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertContactsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertContactsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertContactsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.Contact.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertContactsRequest} returns this
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertContactsRequest} returns this
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Contact contacts = 3;
 * @return {!Array<!proto.suki.pb.ingester.Contact>}
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.getContactsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Contact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Contact, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Contact>} value
 * @return {!proto.suki.pb.ingester.UpsertContactsRequest} returns this
*/
proto.suki.pb.ingester.UpsertContactsRequest.prototype.setContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.Contact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Contact}
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.addContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.Contact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertContactsRequest} returns this
 */
proto.suki.pb.ingester.UpsertContactsRequest.prototype.clearContactsList = function() {
  return this.setContactsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertContactsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertContactsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertContactsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertContactsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedContactsList: jspb.Message.toObjectList(msg.getAddedContactsList(),
    proto.suki.pb.ingester.AddedContact.toObject, includeInstance),
    errorContactsList: jspb.Message.toObjectList(msg.getErrorContactsList(),
    proto.suki.pb.ingester.AddedContact.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertContactsResponse}
 */
proto.suki.pb.ingester.UpsertContactsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertContactsResponse;
  return proto.suki.pb.ingester.UpsertContactsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertContactsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertContactsResponse}
 */
proto.suki.pb.ingester.UpsertContactsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedContact;
      reader.readMessage(value,proto.suki.pb.ingester.AddedContact.deserializeBinaryFromReader);
      msg.addAddedContacts(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedContact;
      reader.readMessage(value,proto.suki.pb.ingester.AddedContact.deserializeBinaryFromReader);
      msg.addErrorContacts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertContactsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertContactsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertContactsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedContact.serializeBinaryToWriter
    );
  }
  f = message.getErrorContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedContact.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedContact added_contacts = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedContact>}
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.getAddedContactsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedContact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedContact, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedContact>} value
 * @return {!proto.suki.pb.ingester.UpsertContactsResponse} returns this
*/
proto.suki.pb.ingester.UpsertContactsResponse.prototype.setAddedContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedContact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedContact}
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.addAddedContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedContact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertContactsResponse} returns this
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.clearAddedContactsList = function() {
  return this.setAddedContactsList([]);
};


/**
 * repeated AddedContact error_contacts = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedContact>}
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.getErrorContactsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedContact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedContact, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedContact>} value
 * @return {!proto.suki.pb.ingester.UpsertContactsResponse} returns this
*/
proto.suki.pb.ingester.UpsertContactsResponse.prototype.setErrorContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedContact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedContact}
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.addErrorContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedContact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertContactsResponse} returns this
 */
proto.suki.pb.ingester.UpsertContactsResponse.prototype.clearErrorContactsList = function() {
  return this.setErrorContactsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetContactsRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetContactsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetContactsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetContactsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contactIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetContactsRequest}
 */
proto.suki.pb.ingester.GetContactsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetContactsRequest;
  return proto.suki.pb.ingester.GetContactsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetContactsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetContactsRequest}
 */
proto.suki.pb.ingester.GetContactsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addContactIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetContactsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetContactsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetContactsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContactIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string contact_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.getContactIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.setContactIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.addContactIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.clearContactIdsList = function() {
  return this.setContactIdsList([]);
};


/**
 * repeated string facility_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
*/
proto.suki.pb.ingester.GetContactsRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetContactsRequest} returns this
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetContactsRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetContactsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetContactsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetContactsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetContactsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetContactsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contactsList: jspb.Message.toObjectList(msg.getContactsList(),
    proto.suki.pb.ingester.Contact.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetContactsResponse}
 */
proto.suki.pb.ingester.GetContactsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetContactsResponse;
  return proto.suki.pb.ingester.GetContactsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetContactsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetContactsResponse}
 */
proto.suki.pb.ingester.GetContactsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.Contact;
      reader.readMessage(value,proto.suki.pb.ingester.Contact.deserializeBinaryFromReader);
      msg.addContacts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetContactsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetContactsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetContactsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetContactsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.Contact.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Contact contacts = 1;
 * @return {!Array<!proto.suki.pb.ingester.Contact>}
 */
proto.suki.pb.ingester.GetContactsResponse.prototype.getContactsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.Contact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.Contact, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.Contact>} value
 * @return {!proto.suki.pb.ingester.GetContactsResponse} returns this
*/
proto.suki.pb.ingester.GetContactsResponse.prototype.setContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.Contact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.Contact}
 */
proto.suki.pb.ingester.GetContactsResponse.prototype.addContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.Contact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetContactsResponse} returns this
 */
proto.suki.pb.ingester.GetContactsResponse.prototype.clearContactsList = function() {
  return this.setContactsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.APLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.APLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.APLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.APLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    aplocationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    aplocationName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    alternativeSpokenName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.APLocation}
 */
proto.suki.pb.ingester.APLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.APLocation;
  return proto.suki.pb.ingester.APLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.APLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.APLocation}
 */
proto.suki.pb.ingester.APLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAplocationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAplocationName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativeSpokenName(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.APLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.APLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.APLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.APLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAplocationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAplocationName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAlternativeSpokenName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string aplocation_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.APLocation.prototype.getAplocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.setAplocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.APLocation.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.APLocation.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string aplocation_name = 4;
 * @return {string}
 */
proto.suki.pb.ingester.APLocation.prototype.getAplocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.setAplocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string alternative_spoken_name = 5;
 * @return {string}
 */
proto.suki.pb.ingester.APLocation.prototype.getAlternativeSpokenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.setAlternativeSpokenName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.APLocation.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
*/
proto.suki.pb.ingester.APLocation.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.APLocation.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.APLocation.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
*/
proto.suki.pb.ingester.APLocation.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.APLocation.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.APLocation.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.APLocation} returns this
*/
proto.suki.pb.ingester.APLocation.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.APLocation} returns this
 */
proto.suki.pb.ingester.APLocation.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.APLocation.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedAPLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedAPLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedAPLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    aplocationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedAPLocation}
 */
proto.suki.pb.ingester.AddedAPLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedAPLocation;
  return proto.suki.pb.ingester.AddedAPLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedAPLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedAPLocation}
 */
proto.suki.pb.ingester.AddedAPLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAplocationId(value);
      break;
    case 3:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedAPLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedAPLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedAPLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAplocationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedAPLocation} returns this
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string aplocation_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.getAplocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedAPLocation} returns this
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.setAplocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddStatus status = 3;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedAPLocation} returns this
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedAPLocation} returns this
 */
proto.suki.pb.ingester.AddedAPLocation.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertAPLocationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    aplocationsList: jspb.Message.toObjectList(msg.getAplocationsList(),
    proto.suki.pb.ingester.APLocation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsRequest}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertAPLocationsRequest;
  return proto.suki.pb.ingester.UpsertAPLocationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsRequest}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.APLocation;
      reader.readMessage(value,proto.suki.pb.ingester.APLocation.deserializeBinaryFromReader);
      msg.addAplocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertAPLocationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAplocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.APLocation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated APLocation aplocations = 3;
 * @return {!Array<!proto.suki.pb.ingester.APLocation>}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.getAplocationsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.APLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.APLocation, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.APLocation>} value
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsRequest} returns this
*/
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.setAplocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.APLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.APLocation}
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.addAplocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.APLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.UpsertAPLocationsRequest.prototype.clearAplocationsList = function() {
  return this.setAplocationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertAPLocationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedAplocationsList: jspb.Message.toObjectList(msg.getAddedAplocationsList(),
    proto.suki.pb.ingester.AddedAPLocation.toObject, includeInstance),
    errorAplocationsList: jspb.Message.toObjectList(msg.getErrorAplocationsList(),
    proto.suki.pb.ingester.AddedAPLocation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsResponse}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertAPLocationsResponse;
  return proto.suki.pb.ingester.UpsertAPLocationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsResponse}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedAPLocation;
      reader.readMessage(value,proto.suki.pb.ingester.AddedAPLocation.deserializeBinaryFromReader);
      msg.addAddedAplocations(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedAPLocation;
      reader.readMessage(value,proto.suki.pb.ingester.AddedAPLocation.deserializeBinaryFromReader);
      msg.addErrorAplocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertAPLocationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedAplocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedAPLocation.serializeBinaryToWriter
    );
  }
  f = message.getErrorAplocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedAPLocation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedAPLocation added_aplocations = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedAPLocation>}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.getAddedAplocationsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedAPLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedAPLocation, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedAPLocation>} value
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsResponse} returns this
*/
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.setAddedAplocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedAPLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedAPLocation}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.addAddedAplocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedAPLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsResponse} returns this
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.clearAddedAplocationsList = function() {
  return this.setAddedAplocationsList([]);
};


/**
 * repeated AddedAPLocation error_aplocations = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedAPLocation>}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.getErrorAplocationsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedAPLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedAPLocation, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedAPLocation>} value
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsResponse} returns this
*/
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.setErrorAplocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedAPLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedAPLocation}
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.addErrorAplocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedAPLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertAPLocationsResponse} returns this
 */
proto.suki.pb.ingester.UpsertAPLocationsResponse.prototype.clearErrorAplocationsList = function() {
  return this.setErrorAplocationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetAPLocationsRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetAPLocationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetAPLocationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAPLocationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    aplocationIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetAPLocationsRequest;
  return proto.suki.pb.ingester.GetAPLocationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetAPLocationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAplocationIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetAPLocationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetAPLocationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAPLocationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAplocationIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string aplocation_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.getAplocationIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.setAplocationIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.addAplocationIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.clearAplocationIdsList = function() {
  return this.setAplocationIdsList([]);
};


/**
 * repeated string facility_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
*/
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetAPLocationsRequest} returns this
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetAPLocationsRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetAPLocationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetAPLocationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetAPLocationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetAPLocationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAPLocationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    aplocationsList: jspb.Message.toObjectList(msg.getAplocationsList(),
    proto.suki.pb.ingester.APLocation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetAPLocationsResponse}
 */
proto.suki.pb.ingester.GetAPLocationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetAPLocationsResponse;
  return proto.suki.pb.ingester.GetAPLocationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetAPLocationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetAPLocationsResponse}
 */
proto.suki.pb.ingester.GetAPLocationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.APLocation;
      reader.readMessage(value,proto.suki.pb.ingester.APLocation.deserializeBinaryFromReader);
      msg.addAplocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetAPLocationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetAPLocationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetAPLocationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAPLocationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAplocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.APLocation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated APLocation aplocations = 1;
 * @return {!Array<!proto.suki.pb.ingester.APLocation>}
 */
proto.suki.pb.ingester.GetAPLocationsResponse.prototype.getAplocationsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.APLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.APLocation, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.APLocation>} value
 * @return {!proto.suki.pb.ingester.GetAPLocationsResponse} returns this
*/
proto.suki.pb.ingester.GetAPLocationsResponse.prototype.setAplocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.APLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.APLocation}
 */
proto.suki.pb.ingester.GetAPLocationsResponse.prototype.addAplocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.APLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetAPLocationsResponse} returns this
 */
proto.suki.pb.ingester.GetAPLocationsResponse.prototype.clearAplocationsList = function() {
  return this.setAplocationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.VoceraBuddy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.VoceraBuddy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.VoceraBuddy.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    buddyUserId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    nickName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.VoceraBuddy}
 */
proto.suki.pb.ingester.VoceraBuddy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.VoceraBuddy;
  return proto.suki.pb.ingester.VoceraBuddy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.VoceraBuddy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.VoceraBuddy}
 */
proto.suki.pb.ingester.VoceraBuddy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuddyUserId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.VoceraBuddy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.VoceraBuddy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.VoceraBuddy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBuddyUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string buddy_user_id = 4;
 * @return {string}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getBuddyUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.setBuddyUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string nick_name = 5;
 * @return {string}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
*/
proto.suki.pb.ingester.VoceraBuddy.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
*/
proto.suki.pb.ingester.VoceraBuddy.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
*/
proto.suki.pb.ingester.VoceraBuddy.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.VoceraBuddy} returns this
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.VoceraBuddy.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedVoceraBuddy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedVoceraBuddy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedVoceraBuddy.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    buddyUserId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    error: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedVoceraBuddy;
  return proto.suki.pb.ingester.AddedVoceraBuddy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedVoceraBuddy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuddyUserId(value);
      break;
    case 4:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedVoceraBuddy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedVoceraBuddy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedVoceraBuddy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBuddyUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy} returns this
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy} returns this
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string buddy_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.getBuddyUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy} returns this
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.setBuddyUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional AddStatus status = 4;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy} returns this
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string error = 5;
 * @return {string}
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy} returns this
 */
proto.suki.pb.ingester.AddedVoceraBuddy.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    voceraBuddiesList: jspb.Message.toObjectList(msg.getVoceraBuddiesList(),
    proto.suki.pb.ingester.VoceraBuddy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertVoceraBuddiesRequest;
  return proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.VoceraBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.VoceraBuddy.deserializeBinaryFromReader);
      msg.addVoceraBuddies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVoceraBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.VoceraBuddy.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated VoceraBuddy vocera_buddies = 3;
 * @return {!Array<!proto.suki.pb.ingester.VoceraBuddy>}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.getVoceraBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.VoceraBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.VoceraBuddy, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.VoceraBuddy>} value
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} returns this
*/
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.setVoceraBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.VoceraBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.VoceraBuddy}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.addVoceraBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.VoceraBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesRequest.prototype.clearVoceraBuddiesList = function() {
  return this.setVoceraBuddiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedVoceraBuddiesList: jspb.Message.toObjectList(msg.getAddedVoceraBuddiesList(),
    proto.suki.pb.ingester.AddedVoceraBuddy.toObject, includeInstance),
    errorVoceraBuddiesList: jspb.Message.toObjectList(msg.getErrorVoceraBuddiesList(),
    proto.suki.pb.ingester.AddedVoceraBuddy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertVoceraBuddiesResponse;
  return proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedVoceraBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.AddedVoceraBuddy.deserializeBinaryFromReader);
      msg.addAddedVoceraBuddies(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedVoceraBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.AddedVoceraBuddy.deserializeBinaryFromReader);
      msg.addErrorVoceraBuddies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedVoceraBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedVoceraBuddy.serializeBinaryToWriter
    );
  }
  f = message.getErrorVoceraBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedVoceraBuddy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedVoceraBuddy added_vocera_buddies = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedVoceraBuddy>}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.getAddedVoceraBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedVoceraBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedVoceraBuddy, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedVoceraBuddy>} value
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} returns this
*/
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.setAddedVoceraBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedVoceraBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.addAddedVoceraBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedVoceraBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} returns this
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.clearAddedVoceraBuddiesList = function() {
  return this.setAddedVoceraBuddiesList([]);
};


/**
 * repeated AddedVoceraBuddy error_vocera_buddies = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedVoceraBuddy>}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.getErrorVoceraBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedVoceraBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedVoceraBuddy, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedVoceraBuddy>} value
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} returns this
*/
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.setErrorVoceraBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedVoceraBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedVoceraBuddy}
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.addErrorVoceraBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedVoceraBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse} returns this
 */
proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.prototype.clearErrorVoceraBuddiesList = function() {
  return this.setErrorVoceraBuddiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.repeatedFields_ = [3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetVoceraBuddiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    buddyUserIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetVoceraBuddiesRequest;
  return proto.suki.pb.ingester.GetVoceraBuddiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addBuddyUserIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetVoceraBuddiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getBuddyUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string user_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated string buddy_user_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.getBuddyUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.setBuddyUserIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.addBuddyUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.clearBuddyUserIdsList = function() {
  return this.setBuddyUserIdsList([]);
};


/**
 * repeated string facility_ids = 5;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
*/
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetVoceraBuddiesRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetVoceraBuddiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    voceraBuddiesList: jspb.Message.toObjectList(msg.getVoceraBuddiesList(),
    proto.suki.pb.ingester.VoceraBuddy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesResponse}
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetVoceraBuddiesResponse;
  return proto.suki.pb.ingester.GetVoceraBuddiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesResponse}
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.VoceraBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.VoceraBuddy.deserializeBinaryFromReader);
      msg.addVoceraBuddies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetVoceraBuddiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVoceraBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.VoceraBuddy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VoceraBuddy vocera_buddies = 1;
 * @return {!Array<!proto.suki.pb.ingester.VoceraBuddy>}
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.prototype.getVoceraBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.VoceraBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.VoceraBuddy, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.VoceraBuddy>} value
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesResponse} returns this
*/
proto.suki.pb.ingester.GetVoceraBuddiesResponse.prototype.setVoceraBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.VoceraBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.VoceraBuddy}
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.prototype.addVoceraBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.VoceraBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetVoceraBuddiesResponse} returns this
 */
proto.suki.pb.ingester.GetVoceraBuddiesResponse.prototype.clearVoceraBuddiesList = function() {
  return this.setVoceraBuddiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.OutsideBuddy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.OutsideBuddy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.OutsideBuddy.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    buddyUserId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    nickName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.OutsideBuddy}
 */
proto.suki.pb.ingester.OutsideBuddy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.OutsideBuddy;
  return proto.suki.pb.ingester.OutsideBuddy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.OutsideBuddy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.OutsideBuddy}
 */
proto.suki.pb.ingester.OutsideBuddy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuddyUserId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.OutsideBuddy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.OutsideBuddy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.OutsideBuddy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBuddyUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeletedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string facility_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string buddy_user_id = 4;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getBuddyUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setBuddyUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string nick_name = 5;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string first_name = 6;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string last_name = 7;
 * @return {string}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
*/
proto.suki.pb.ingester.OutsideBuddy.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
*/
proto.suki.pb.ingester.OutsideBuddy.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp deleted_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.getDeletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
*/
proto.suki.pb.ingester.OutsideBuddy.prototype.setDeletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.OutsideBuddy} returns this
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.clearDeletedAt = function() {
  return this.setDeletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.OutsideBuddy.prototype.hasDeletedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddedOutsideBuddy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddedOutsideBuddy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedOutsideBuddy.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    buddyUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddedOutsideBuddy;
  return proto.suki.pb.ingester.AddedOutsideBuddy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddedOutsideBuddy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuddyUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.suki.pb.ingester.AddStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddedOutsideBuddy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddedOutsideBuddy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddedOutsideBuddy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBuddyUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy} returns this
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string buddy_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.getBuddyUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy} returns this
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.setBuddyUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddStatus status = 3;
 * @return {!proto.suki.pb.ingester.AddStatus}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.getStatus = function() {
  return /** @type {!proto.suki.pb.ingester.AddStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.suki.pb.ingester.AddStatus} value
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy} returns this
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy} returns this
 */
proto.suki.pb.ingester.AddedOutsideBuddy.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    outsideBuddiesList: jspb.Message.toObjectList(msg.getOutsideBuddiesList(),
    proto.suki.pb.ingester.OutsideBuddy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertOutsideBuddiesRequest;
  return proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    case 3:
      var value = new proto.suki.pb.ingester.OutsideBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.OutsideBuddy.deserializeBinaryFromReader);
      msg.addOutsideBuddies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOutsideBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.suki.pb.ingester.OutsideBuddy.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated OutsideBuddy outside_buddies = 3;
 * @return {!Array<!proto.suki.pb.ingester.OutsideBuddy>}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.getOutsideBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.OutsideBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.OutsideBuddy, 3));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.OutsideBuddy>} value
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} returns this
*/
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.setOutsideBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.suki.pb.ingester.OutsideBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.OutsideBuddy}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.addOutsideBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.suki.pb.ingester.OutsideBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesRequest.prototype.clearOutsideBuddiesList = function() {
  return this.setOutsideBuddiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addedOutsideBuddiesList: jspb.Message.toObjectList(msg.getAddedOutsideBuddiesList(),
    proto.suki.pb.ingester.AddedOutsideBuddy.toObject, includeInstance),
    errorOutsideBuddiesList: jspb.Message.toObjectList(msg.getErrorOutsideBuddiesList(),
    proto.suki.pb.ingester.AddedOutsideBuddy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.UpsertOutsideBuddiesResponse;
  return proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AddedOutsideBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.AddedOutsideBuddy.deserializeBinaryFromReader);
      msg.addAddedOutsideBuddies(value);
      break;
    case 2:
      var value = new proto.suki.pb.ingester.AddedOutsideBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.AddedOutsideBuddy.deserializeBinaryFromReader);
      msg.addErrorOutsideBuddies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddedOutsideBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AddedOutsideBuddy.serializeBinaryToWriter
    );
  }
  f = message.getErrorOutsideBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.suki.pb.ingester.AddedOutsideBuddy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddedOutsideBuddy added_outside_buddies = 1;
 * @return {!Array<!proto.suki.pb.ingester.AddedOutsideBuddy>}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.getAddedOutsideBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedOutsideBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedOutsideBuddy, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedOutsideBuddy>} value
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} returns this
*/
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.setAddedOutsideBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedOutsideBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.addAddedOutsideBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AddedOutsideBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} returns this
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.clearAddedOutsideBuddiesList = function() {
  return this.setAddedOutsideBuddiesList([]);
};


/**
 * repeated AddedOutsideBuddy error_outside_buddies = 2;
 * @return {!Array<!proto.suki.pb.ingester.AddedOutsideBuddy>}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.getErrorOutsideBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AddedOutsideBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AddedOutsideBuddy, 2));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AddedOutsideBuddy>} value
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} returns this
*/
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.setErrorOutsideBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.suki.pb.ingester.AddedOutsideBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AddedOutsideBuddy}
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.addErrorOutsideBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.suki.pb.ingester.AddedOutsideBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse} returns this
 */
proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.prototype.clearErrorOutsideBuddiesList = function() {
  return this.setErrorOutsideBuddiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.repeatedFields_ = [3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetOutsideBuddiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    buddyUserIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    facilityIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    lastUpdatedTime: (f = msg.getLastUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetOutsideBuddiesRequest;
  return proto.suki.pb.ingester.GetOutsideBuddiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addBuddyUserIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addFacilityIds(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdatedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetOutsideBuddiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getBuddyUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getFacilityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getLastUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string user_ids = 3;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated string buddy_user_ids = 4;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.getBuddyUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.setBuddyUserIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.addBuddyUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.clearBuddyUserIdsList = function() {
  return this.setBuddyUserIdsList([]);
};


/**
 * repeated string facility_ids = 5;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.getFacilityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.setFacilityIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.addFacilityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.clearFacilityIdsList = function() {
  return this.setFacilityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp last_updated_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.getLastUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
*/
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.setLastUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.clearLastUpdatedTime = function() {
  return this.setLastUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetOutsideBuddiesRequest.prototype.hasLastUpdatedTime = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetOutsideBuddiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    outsideBuddiesList: jspb.Message.toObjectList(msg.getOutsideBuddiesList(),
    proto.suki.pb.ingester.OutsideBuddy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesResponse}
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetOutsideBuddiesResponse;
  return proto.suki.pb.ingester.GetOutsideBuddiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesResponse}
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.OutsideBuddy;
      reader.readMessage(value,proto.suki.pb.ingester.OutsideBuddy.deserializeBinaryFromReader);
      msg.addOutsideBuddies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetOutsideBuddiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutsideBuddiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.OutsideBuddy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OutsideBuddy outside_buddies = 1;
 * @return {!Array<!proto.suki.pb.ingester.OutsideBuddy>}
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.prototype.getOutsideBuddiesList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.OutsideBuddy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.OutsideBuddy, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.OutsideBuddy>} value
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesResponse} returns this
*/
proto.suki.pb.ingester.GetOutsideBuddiesResponse.prototype.setOutsideBuddiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.OutsideBuddy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.OutsideBuddy}
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.prototype.addOutsideBuddies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.OutsideBuddy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetOutsideBuddiesResponse} returns this
 */
proto.suki.pb.ingester.GetOutsideBuddiesResponse.prototype.clearOutsideBuddiesList = function() {
  return this.setOutsideBuddiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteFacilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteFacilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteFacilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    facilityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteFacilityRequest}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteFacilityRequest;
  return proto.suki.pb.ingester.DeleteFacilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteFacilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteFacilityRequest}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacilityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteFacilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteFacilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteFacilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFacilityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteFacilityRequest} returns this
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string facility_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.getFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteFacilityRequest} returns this
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.setFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string request_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteFacilityRequest} returns this
 */
proto.suki.pb.ingester.DeleteFacilityRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteGroupRequest}
 */
proto.suki.pb.ingester.DeleteGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteGroupRequest;
  return proto.suki.pb.ingester.DeleteGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteGroupRequest}
 */
proto.suki.pb.ingester.DeleteGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteGroupRequest} returns this
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteGroupRequest} returns this
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string request_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteGroupRequest} returns this
 */
proto.suki.pb.ingester.DeleteGroupRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteUserRequest}
 */
proto.suki.pb.ingester.DeleteUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteUserRequest;
  return proto.suki.pb.ingester.DeleteUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteUserRequest}
 */
proto.suki.pb.ingester.DeleteUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteUserRequest} returns this
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteUserRequest} returns this
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string request_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteUserRequest} returns this
 */
proto.suki.pb.ingester.DeleteUserRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteAPLocationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteAPLocationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    aplocationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteAPLocationRequest}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteAPLocationRequest;
  return proto.suki.pb.ingester.DeleteAPLocationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteAPLocationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteAPLocationRequest}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAplocationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteAPLocationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteAPLocationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAplocationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteAPLocationRequest} returns this
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string aplocation_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.getAplocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteAPLocationRequest} returns this
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.setAplocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string request_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteAPLocationRequest} returns this
 */
proto.suki.pb.ingester.DeleteAPLocationRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteContactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteContactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteContactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteContactRequest}
 */
proto.suki.pb.ingester.DeleteContactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteContactRequest;
  return proto.suki.pb.ingester.DeleteContactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteContactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteContactRequest}
 */
proto.suki.pb.ingester.DeleteContactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteContactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteContactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteContactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteContactRequest} returns this
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contact_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.getContactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteContactRequest} returns this
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.setContactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string request_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteContactRequest} returns this
 */
proto.suki.pb.ingester.DeleteContactRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteVoceraBuddyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    buddyUserId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteVoceraBuddyRequest;
  return proto.suki.pb.ingester.DeleteVoceraBuddyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuddyUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteVoceraBuddyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBuddyUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string buddy_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.getBuddyUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.setBuddyUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string request_user_id = 4;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteVoceraBuddyRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.DeleteOutsideBuddyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    buddyUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestUserId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.DeleteOutsideBuddyRequest;
  return proto.suki.pb.ingester.DeleteOutsideBuddyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuddyUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.DeleteOutsideBuddyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBuddyUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string buddy_user_id = 2;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.getBuddyUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.setBuddyUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string request_user_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.getRequestUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} returns this
 */
proto.suki.pb.ingester.DeleteOutsideBuddyRequest.prototype.setRequestUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AnalyticsTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AnalyticsTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AnalyticsTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    intentDetectionMs: jspb.Message.getFieldWithDefault(msg, 2, 0),
    entireTransactionMs: jspb.Message.getFieldWithDefault(msg, 3, 0),
    voceraSessionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    voceraDoctorUserId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    voceraProjectId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    voceraFacilityId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    inputClientContext: jspb.Message.getFieldWithDefault(msg, 8, ""),
    inputIntentContext: jspb.Message.getFieldWithDefault(msg, 9, ""),
    inputIntentText: jspb.Message.getFieldWithDefault(msg, 10, ""),
    transactionTime: (f = msg.getTransactionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    audiofilePath: jspb.Message.getFieldWithDefault(msg, 12, ""),
    audioDurationMs: jspb.Message.getFieldWithDefault(msg, 13, 0),
    audioBytes: jspb.Message.getFieldWithDefault(msg, 14, 0),
    intentResponse: jspb.Message.getFieldWithDefault(msg, 15, ""),
    internal: jspb.Message.getBooleanFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction}
 */
proto.suki.pb.ingester.AnalyticsTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AnalyticsTransaction;
  return proto.suki.pb.ingester.AnalyticsTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AnalyticsTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction}
 */
proto.suki.pb.ingester.AnalyticsTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntentDetectionMs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEntireTransactionMs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoceraSessionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoceraDoctorUserId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoceraProjectId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoceraFacilityId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputClientContext(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputIntentContext(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setInputIntentText(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactionTime(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiofilePath(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAudioDurationMs(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAudioBytes(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntentResponse(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInternal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AnalyticsTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AnalyticsTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AnalyticsTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntentDetectionMs();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEntireTransactionMs();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getVoceraSessionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVoceraDoctorUserId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVoceraProjectId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVoceraFacilityId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getInputClientContext();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getInputIntentContext();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getInputIntentText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTransactionTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAudiofilePath();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAudioDurationMs();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getAudioBytes();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getIntentResponse();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getInternal();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional string request_uuid = 1;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getRequestUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setRequestUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 intent_detection_ms = 2;
 * @return {number}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getIntentDetectionMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setIntentDetectionMs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 entire_transaction_ms = 3;
 * @return {number}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getEntireTransactionMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setEntireTransactionMs = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string vocera_session_id = 4;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getVoceraSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setVoceraSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string vocera_doctor_user_id = 5;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getVoceraDoctorUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setVoceraDoctorUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string vocera_project_id = 6;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getVoceraProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setVoceraProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string vocera_facility_id = 7;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getVoceraFacilityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setVoceraFacilityId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string input_client_context = 8;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getInputClientContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setInputClientContext = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string input_intent_context = 9;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getInputIntentContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setInputIntentContext = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string input_intent_text = 10;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getInputIntentText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setInputIntentText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp transaction_time = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getTransactionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
*/
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setTransactionTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.clearTransactionTime = function() {
  return this.setTransactionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.hasTransactionTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string audiofile_path = 12;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getAudiofilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setAudiofilePath = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 audio_duration_ms = 13;
 * @return {number}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getAudioDurationMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setAudioDurationMs = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 audio_bytes = 14;
 * @return {number}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getAudioBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setAudioBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string intent_response = 15;
 * @return {string}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getIntentResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setIntentResponse = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool internal = 16;
 * @return {boolean}
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.getInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction} returns this
 */
proto.suki.pb.ingester.AnalyticsTransaction.prototype.setInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.AddAnalyticsTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    transaction: (f = msg.getTransaction()) && proto.suki.pb.ingester.AnalyticsTransaction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest}
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.AddAnalyticsTransactionRequest;
  return proto.suki.pb.ingester.AddAnalyticsTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest}
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AnalyticsTransaction;
      reader.readMessage(value,proto.suki.pb.ingester.AnalyticsTransaction.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.AddAnalyticsTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.suki.pb.ingester.AnalyticsTransaction.serializeBinaryToWriter
    );
  }
};


/**
 * optional AnalyticsTransaction transaction = 1;
 * @return {?proto.suki.pb.ingester.AnalyticsTransaction}
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.prototype.getTransaction = function() {
  return /** @type{?proto.suki.pb.ingester.AnalyticsTransaction} */ (
    jspb.Message.getWrapperField(this, proto.suki.pb.ingester.AnalyticsTransaction, 1));
};


/**
 * @param {?proto.suki.pb.ingester.AnalyticsTransaction|undefined} value
 * @return {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} returns this
*/
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} returns this
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.AddAnalyticsTransactionRequest.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startTime: (f = msg.getStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    projectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    limit: jspb.Message.getFieldWithDefault(msg, 5, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 6, 0),
    requestIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    organizationId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    exportRequested: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetAnalyticsTransactionsRequest;
  return proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequestIds(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExportRequested(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRequestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExportRequested();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
*/
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
*/
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 limit = 5;
 * @return {number}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 offset = 6;
 * @return {number}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated string request_ids = 7;
 * @return {!Array<string>}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getRequestIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setRequestIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.addRequestIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.clearRequestIdsList = function() {
  return this.setRequestIdsList([]);
};


/**
 * optional string organization_id = 8;
 * @return {string}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool export_requested = 9;
 * @return {boolean}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.getExportRequested = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsRequest.prototype.setExportRequested = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.suki.pb.ingester.AnalyticsTransaction.toObject, includeInstance),
    nextOffset: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetAnalyticsTransactionsResponse;
  return proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.AnalyticsTransaction;
      reader.readMessage(value,proto.suki.pb.ingester.AnalyticsTransaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNextOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.suki.pb.ingester.AnalyticsTransaction.serializeBinaryToWriter
    );
  }
  f = message.getNextOffset();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated AnalyticsTransaction transactions = 1;
 * @return {!Array<!proto.suki.pb.ingester.AnalyticsTransaction>}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.suki.pb.ingester.AnalyticsTransaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.suki.pb.ingester.AnalyticsTransaction, 1));
};


/**
 * @param {!Array<!proto.suki.pb.ingester.AnalyticsTransaction>} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse} returns this
*/
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.suki.pb.ingester.AnalyticsTransaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.suki.pb.ingester.AnalyticsTransaction}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.suki.pb.ingester.AnalyticsTransaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * optional int32 next_offset = 2;
 * @return {number}
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.getNextOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse} returns this
 */
proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.prototype.setNextOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.TableUpdatedTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.TableUpdatedTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.TableUpdatedTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersUpdatedAt: (f = msg.getUsersUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    groupsUpdatedAt: (f = msg.getGroupsUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contactsUpdatedAt: (f = msg.getContactsUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    voceraBuddiesUpdatedAt: (f = msg.getVoceraBuddiesUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    outsideBuddiesUpdatedAt: (f = msg.getOutsideBuddiesUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    aplocationsUpdatedAt: (f = msg.getAplocationsUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    facilitiesUpdatedAt: (f = msg.getFacilitiesUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime}
 */
proto.suki.pb.ingester.TableUpdatedTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.TableUpdatedTime;
  return proto.suki.pb.ingester.TableUpdatedTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.TableUpdatedTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime}
 */
proto.suki.pb.ingester.TableUpdatedTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUsersUpdatedAt(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGroupsUpdatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContactsUpdatedAt(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setVoceraBuddiesUpdatedAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOutsideBuddiesUpdatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAplocationsUpdatedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFacilitiesUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.TableUpdatedTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.TableUpdatedTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.TableUpdatedTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getGroupsUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContactsUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getVoceraBuddiesUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOutsideBuddiesUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAplocationsUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFacilitiesUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp users_updated_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getUsersUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setUsersUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearUsersUpdatedAt = function() {
  return this.setUsersUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasUsersUpdatedAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp groups_updated_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getGroupsUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setGroupsUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearGroupsUpdatedAt = function() {
  return this.setGroupsUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasGroupsUpdatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp contacts_updated_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getContactsUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setContactsUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearContactsUpdatedAt = function() {
  return this.setContactsUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasContactsUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp vocera_buddies_updated_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getVoceraBuddiesUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setVoceraBuddiesUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearVoceraBuddiesUpdatedAt = function() {
  return this.setVoceraBuddiesUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasVoceraBuddiesUpdatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp outside_buddies_updated_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getOutsideBuddiesUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setOutsideBuddiesUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearOutsideBuddiesUpdatedAt = function() {
  return this.setOutsideBuddiesUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasOutsideBuddiesUpdatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp aplocations_updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getAplocationsUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setAplocationsUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearAplocationsUpdatedAt = function() {
  return this.setAplocationsUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasAplocationsUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp facilities_updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.getFacilitiesUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
*/
proto.suki.pb.ingester.TableUpdatedTime.prototype.setFacilitiesUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.TableUpdatedTime} returns this
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.clearFacilitiesUpdatedAt = function() {
  return this.setFacilitiesUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.TableUpdatedTime.prototype.hasFacilitiesUpdatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.suki.pb.ingester.GetDBMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.suki.pb.ingester.GetDBMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.suki.pb.ingester.GetDBMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetDBMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tablesUpdatedAt: (f = msg.getTablesUpdatedAt()) && proto.suki.pb.ingester.TableUpdatedTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.suki.pb.ingester.GetDBMetadataResponse}
 */
proto.suki.pb.ingester.GetDBMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.suki.pb.ingester.GetDBMetadataResponse;
  return proto.suki.pb.ingester.GetDBMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.suki.pb.ingester.GetDBMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.suki.pb.ingester.GetDBMetadataResponse}
 */
proto.suki.pb.ingester.GetDBMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.suki.pb.ingester.TableUpdatedTime;
      reader.readMessage(value,proto.suki.pb.ingester.TableUpdatedTime.deserializeBinaryFromReader);
      msg.setTablesUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.suki.pb.ingester.GetDBMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.suki.pb.ingester.GetDBMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.suki.pb.ingester.GetDBMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.suki.pb.ingester.GetDBMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTablesUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.suki.pb.ingester.TableUpdatedTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableUpdatedTime tables_updated_at = 1;
 * @return {?proto.suki.pb.ingester.TableUpdatedTime}
 */
proto.suki.pb.ingester.GetDBMetadataResponse.prototype.getTablesUpdatedAt = function() {
  return /** @type{?proto.suki.pb.ingester.TableUpdatedTime} */ (
    jspb.Message.getWrapperField(this, proto.suki.pb.ingester.TableUpdatedTime, 1));
};


/**
 * @param {?proto.suki.pb.ingester.TableUpdatedTime|undefined} value
 * @return {!proto.suki.pb.ingester.GetDBMetadataResponse} returns this
*/
proto.suki.pb.ingester.GetDBMetadataResponse.prototype.setTablesUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.suki.pb.ingester.GetDBMetadataResponse} returns this
 */
proto.suki.pb.ingester.GetDBMetadataResponse.prototype.clearTablesUpdatedAt = function() {
  return this.setTablesUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.suki.pb.ingester.GetDBMetadataResponse.prototype.hasTablesUpdatedAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.suki.pb.ingester.AddStatus = {
  NONE: 0,
  ADDED: 1,
  UPDATED: 2,
  ERROR: 3
};

goog.object.extend(exports, proto.suki.pb.ingester);
